var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { Component, Input } from '@angular/core';
import { HisotryCurveRefreshCycle } from './hisotry-curve-refresh-cycle';
import { HistoryCurveDisplayPeriod } from './history-curve-display-period';
import { CurveType } from '../../../../view-data/components/history-curve/general/curve-type';
var HistoryCurveGeneralSettingComponent = /** @class */ (function (_super) {
    __extends(HistoryCurveGeneralSettingComponent, _super);
    function HistoryCurveGeneralSettingComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.refreshCycles = new HisotryCurveRefreshCycle();
        _this.displayPeriods = new HistoryCurveDisplayPeriod();
        _this.currveTypeEnum = CurveType;
        return _this;
    }
    Object.defineProperty(HistoryCurveGeneralSettingComponent.prototype, "curveType", {
        get: function () {
            return this.data.curveType;
        },
        set: function (value) {
            this.data.curveType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveGeneralSettingComponent.prototype, "displayPeriod", {
        get: function () {
            return this.data.displayPeriod;
        },
        set: function (value) {
            this.data.displayPeriod = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HistoryCurveGeneralSettingComponent.prototype, "refreshCycle", {
        get: function () {
            return this.data.refreshCycle;
        },
        set: function (value) {
            this.data.refreshCycle = value;
        },
        enumerable: true,
        configurable: true
    });
    HistoryCurveGeneralSettingComponent.prototype.ngOnInit = function () {
        this.data.curveType = this.data.curveType === undefined ? CurveType.Line : this.data.curveType;
    };
    HistoryCurveGeneralSettingComponent.prototype.validate = function () {
        return true;
    };
    __decorate([
        Input()
    ], HistoryCurveGeneralSettingComponent.prototype, "data", void 0);
    HistoryCurveGeneralSettingComponent = __decorate([
        Component({
            selector: 'history-curve-general',
            styles: [".sepeator{ width:100%; clear:both; margin-top:10px; } .general-select{ width: 100%; border: 1px solid #d7dbe5; color: #666666; font-size: 14px; padding: 0 0 0 5px; } .half-line{ width: calc(50% - 10px); height: 30px; } .half-line:nth-child(2n){ margin-left: 20px; } .line,.bar-group,.bar-stack{ width: 60px; height: 60px; border: 1px solid #d7dbe5; } .bar-group,.bar-stack{ margin-left: 10px; } .history-curve-active{ border: 1px solid #3695ff; } .graph{ display: flex; justify-content: flex-start; align-items: center; margin-bottom: 20px; } .fcloud-line,.fcloud-bar-group,.fcloud-bar-stack{ font-size:60px; background: none; border-right: none; cursor: pointer; } .fcloud-line span,.fcloud-bar-group span,.fcloud-bar-stack span{ display: inline; padding: 0; border-right: none; position: relative; top: 0; } "],
            template: "<form novalidate #form=\"ngForm\" name=\"generalForm\"> <div class=\"fe-modal-container\"> <div class=\"fe-modal-content\"> <div class=\"fe-modal-body graph\"> <div class=\"line\" [ngClass]=\"{'history-curve-active':curveType === currveTypeEnum.Line}\" (click)=\"curveType=currveTypeEnum.Line\"> <span class=\"fcloud-line\" [ngClass]=\"{'fcloud-line-active':curveType === currveTypeEnum.Line}\"> <span class=\"path1\"></span> <span class=\"path2\"></span> <span class=\"path3\"></span> <span class=\"path4\"></span> </span> </div> <div class=\"bar-group\" [ngClass]=\"{'history-curve-active':curveType === currveTypeEnum.BarGroup}\" (click)=\"curveType=currveTypeEnum.BarGroup\"> <span class=\"fcloud-bar-group\" [ngClass]=\"{'fcloud-bar-group-active':curveType === currveTypeEnum.BarGroup}\"> <span class=\"path1\"></span> <span class=\"path2\"></span> <span class=\"path3\"></span> <span class=\"path4\"></span> <span class=\"path5\"></span> </span> </div> <div class=\"bar-stack\" [ngClass]=\"{'history-curve-active':curveType === currveTypeEnum.BarStack}\" (click)=\"curveType=currveTypeEnum.BarStack\"> <span class=\"fcloud-bar-stack\" [ngClass]=\"{'fcloud-bar-stack-active':curveType === currveTypeEnum.BarStack}\"> <span class=\"path1\"></span> <span class=\"path2\"></span> <span class=\"path3\"></span> <span class=\"path4\"></span> <span class=\"path5\"></span> </span> </div> </div> <div class=\"clearfix\"> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc('RefreshCycle')}}:</label> <select name=\"refreshCycle\" class=\"fe-vertical-input\" [(ngModel)]=\"refreshCycle\"> <option *ngFor=\"let cycle of refreshCycles\" [ngValue]=\"cycle.value\">{{lc(cycle.displayName)}} </option> </select> </div> <div class=\"fe-vertical-label fe-half-line\"> <label class=\"fe-vertical-title\">{{lc('DisplayPeriod')}}:</label> <select name=\"displayPeriod\" class=\"fe-vertical-input\" [(ngModel)]=\"displayPeriod\"> <option *ngFor=\"let period of displayPeriods\" [ngValue]=\"period.value\">{{lc(period.displayName)}} </option> </select> </div> </div> </div> </div> </form>"
        })
    ], HistoryCurveGeneralSettingComponent);
    return HistoryCurveGeneralSettingComponent;
}(ConfigureComponentBase));
export { HistoryCurveGeneralSettingComponent };
